import { render, staticRenderFns } from "./CustomizeMetalAL.vue?vue&type=template&id=4eae4006&scoped=true"
import script from "./CustomizeMetalAL.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAL.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAL.vue?vue&type=style&index=0&id=4eae4006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eae4006",
  null
  
)

export default component.exports